import React from "react";
import { MapPin, Navigation, Clock } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StepsFromTheSacred() {
  return <section data-section-id="224794" id="reach-out-to-us" className="bg-background text-foreground w-full overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-12 min-h-[600px] lg:min-h-[800px]">
        
        {}
        <div className="lg:col-span-7 relative bg-secondary/30 flex items-center justify-center min-h-[400px] lg:min-h-auto overflow-hidden group">
          {}
          <div className="absolute inset-0 bg-cover bg-center opacity-40 transition-transform duration-1000 group-hover:scale-105" style={{
          backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/brighton_healthcare_map.png')"
        }} />
          
          {}
          <div className="absolute inset-0 bg-gradient-to-r from-background/90 via-transparent to-transparent lg:hidden" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/90 via-transparent to-transparent lg:hidden" />

          {}
          <div className="relative z-10 w-full max-w-md aspect-square flex items-center justify-center">
            {}
            <svg className="absolute inset-0 w-full h-full drop-shadow-sm" viewBox="0 0 100 100" preserveAspectRatio="none">
              <path d="M 20 80 Q 50 50 80 20" fill="none" stroke="var(--primary)" strokeWidth="0.5" strokeDasharray="4 4" className="opacity-40" />
            </svg>

            {}
            <div className="absolute bottom-[15%] left-[15%] flex flex-col items-center animate-pulse">
              <div className="bg-primary text-primary-foreground p-3 rounded-lg shadow-lg shadow-primary/10 mb-2">
                <MapPin className="size-6" />
              </div>
              <span className="text-primary font-default font-semibold text-sm tracking-wider bg-background/95 px-3 py-1 rounded-md backdrop-blur-sm border border-primary/10">
                BN2 9AA
              </span>
            </div>

            {}
            <div className="absolute top-[15%] right-[15%] flex flex-col items-center">
              <div className="bg-white text-primary border-2 border-primary/20 p-4 rounded-lg shadow-xl shadow-primary/5 mb-2 relative">
                <div className="absolute inset-0 rounded-lg border border-primary/30 animate-ping opacity-30" />
                <Navigation className="size-8" />
              </div>
              <span className="text-foreground font-default font-bold text-base tracking-tight bg-background/95 px-4 py-1.5 rounded-md backdrop-blur-md border border-border shadow-md">
                Richmond Parade
              </span>
            </div>

            {}
            <div className="absolute top-8 left-8 bg-background/95 backdrop-blur-md border border-border p-4 rounded-lg shadow-xl flex items-center gap-4">
              <div className="bg-primary/5 p-2 rounded-lg">
                <Clock className="size-5 text-primary" />
              </div>
              <div>
                <p className="text-xs text-muted-foreground uppercase tracking-wider font-semibold">Response Time</p>
                <p className="text-primary font-default font-bold text-lg">24/7 Support</p>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-5 bg-secondary flex flex-col justify-center p-8 sm:p-12 lg:p-16 xl:p-24 relative z-20">
          {}
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--primary)_1px,_transparent_1px)] bg-[size:32px_32px]" />
          
          <div className="relative z-10 max-w-xl">
            <Badge variant="outline" className="mb-8 border-primary/30 text-primary bg-primary/5 px-4 py-1.5 text-sm uppercase tracking-widest font-semibold rounded-md">
              CQC Registered
            </Badge>
            
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-default font-bold text-foreground mb-6 leading-tight">
              Reach Out to Us
            </h2>
            
            <div className="space-y-6 text-muted-foreground text-lg sm:text-xl font-default leading-relaxed mb-10">
              <p>
                Located in the heart of Brighton, Cynthylee Health Care provides compassionate home care services tailored to your family's unique needs.
              </p>
              <p className="italic font-serif text-primary/80">
                "Our mission is to bring premium, professional care directly to your doorstep with warmth and dignity."
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 text-base h-14 px-8 rounded-md shadow-md">
                <Link href="/ContactPage">
                  Get Directions
                  <Navigation className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary/20 text-primary hover:bg-primary/5 text-base h-14 px-8 bg-white rounded-md shadow-sm">
                <Link href="/ServicesPage">
                  Our Services
                </Link>
              </Button>
            </div>
          </div>
        </div>

      </div>
    </section>;
}